import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/* A quantity the way a human reads it.

   New records carry the pack the customer chose, so a pack_size of "120 Tablets" with a
   quantity of 3 has to read as "3 x 120 Tablets". A pharmacy technician checking the
   dispensable amount against a prescription cannot do that from a bare "3".

   Older records put the pack size itself in quantity and carry no pack at all, so they
   fall through to the plain number they have always shown.

   Accepts either an estimate (pack_size + quantity) or an order medication block
   (pack_size + packs), which is why it reads packs first and quantity second.
   Mirrors _qty_display in backend/server.py. Keep the two in step. */
export function qtyDisplay(d) {
  if (!d) return "";
  const pack = String(d.pack_size || "").trim();
  if (!pack) return String(d.quantity ?? "");
  const raw = d.packs !== undefined && d.packs !== null ? d.packs : d.quantity;
  const parsed = parseInt(raw, 10);
  const packs = Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
  return packs > 1 ? `${packs} x ${pack}` : pack;
}

/* Same shape, for when the pack count and the pack are already separate values. */
export function packsLabel(n, pack) {
  const p = String(pack || "").trim();
  if (!p) return String(n);
  return n > 1 ? `${n} x ${p}` : p;
}
